var map = {
	"./0categorias-capas/atualidades-e-negocios/1.jpg": [
		138,
		0
	],
	"./0categorias-capas/celebridades-e-tv/1.jpg": [
		139,
		3
	],
	"./0categorias-capas/criancas-e-quadrinhos/1.jpg": [
		140,
		6
	],
	"./0categorias-capas/decoracao-e-jardinagem/1.jpg": [
		141,
		9
	],
	"./0categorias-capas/especializadas/1.jpg": [
		142,
		12
	],
	"./0categorias-capas/esportes/1.jpg": [
		143,
		15
	],
	"./0categorias-capas/estilo-de-vida-e-moda/1.jpg": [
		144,
		18
	],
	"./0categorias-capas/games-e-tecnologia/1.jpg": [
		145,
		21
	],
	"./0categorias-capas/gastronomia-e-receitas/1.jpg": [
		146,
		24
	],
	"./0categorias-capas/historia-e-educacao/1.jpg": [
		147,
		27
	],
	"./0categorias-capas/saude-e-bem-estar/1.jpg": [
		148,
		30
	],
	"./0categorias-capas/viagens-e-lazer/1.jpg": [
		149,
		33
	],
	"./almanaque-da-saude/1.jpg": [
		396,
		39
	],
	"./ana-maria/1.jpg": [
		397,
		42
	],
	"./arte-em-festas-infantis/1.jpg": [
		398,
		45
	],
	"./arte-em-patchwork/1.jpg": [
		399,
		48
	],
	"./auto-esporte/1.jpg": [
		400,
		51
	],
	"./aventuras-na-historia/1.jpg": [
		401,
		54
	],
	"./aventuras-na-história/1.jpg": [
		402,
		57
	],
	"./bichos-em-casa/1.jpg": [
		403,
		60
	],
	"./bicycling/1.jpg": [
		404,
		63
	],
	"./bons-fluidos/1.jpg": [
		405,
		66
	],
	"./caras/1.jpg": [
		406,
		69
	],
	"./carros-classicos-&-cia/1.jpg": [
		407,
		72
	],
	"./carros-clássicos-&-cia/1.jpg": [
		408,
		75
	],
	"./casa-&-ambiente-banheiros-&-lavabos/1.jpg": [
		409,
		78
	],
	"./casa-&-ambiente-bebes/1.jpg": [
		410,
		81
	],
	"./casa-&-ambiente-bebês/1.jpg": [
		411,
		84
	],
	"./casa-&-ambiente-cozinhas-&-salas-de-almoco/1.jpg": [
		412,
		87
	],
	"./casa-&-ambiente-quartos-&-closets/1.jpg": [
		413,
		90
	],
	"./casa-&-ambiente-salas-&-livings/1.jpg": [
		414,
		93
	],
	"./casa-&-decoracao/1.jpg": [
		415,
		96
	],
	"./casa-&-decoração/1.jpg": [
		416,
		99
	],
	"./casa-e-jardim/1.jpg": [
		417,
		102
	],
	"./casa-interiores-&-paisagismo/1.jpg": [
		418,
		105
	],
	"./casa-vogue/1.jpg": [
		419,
		108
	],
	"./casas-pequenas/1.jpg": [
		420,
		111
	],
	"./colecao-almanaque-da-saude/1.jpg": [
		421,
		114
	],
	"./conceito-av-noivas/1.jpg": [
		423,
		117
	],
	"./conceito-av/1.jpg": [
		422,
		120
	],
	"./conhecimento-pratico-lingua-portuguesa/1.jpg": [
		424,
		123
	],
	"./contigo-novelas/1.jpg": [
		426,
		126
	],
	"./contigo/1.jpg": [
		425,
		129
	],
	"./crescer/1.jpg": [
		427,
		132
	],
	"./decoracao-&-estilo-casa/1.jpg": [
		428,
		135
	],
	"./decoracao-&-estilo-festa/1.jpg": [
		429,
		138
	],
	"./decorando-álbuns-scrapbooking/1.jpg": [
		430,
		141
	],
	"./dinheiro-rural/1.jpg": [
		431,
		144
	],
	"./disney-historias/1.jpg": [
		432,
		147
	],
	"./disney-histórias/1.jpg": [
		433,
		150
	],
	"./epoca-negocios/1.jpg": [
		435,
		153
	],
	"./epoca/1.jpg": [
		434,
		156
	],
	"./espresso/1.jpg": [
		436,
		159
	],
	"./figurino-noivas/1.jpg": [
		437,
		162
	],
	"./filosofia-ciencia-&-vida/1.jpg": [
		438,
		165
	],
	"./filosofia-ciência-&-vida/1.jpg": [
		439,
		168
	],
	"./fotografe-melhor/1.jpg": [
		440,
		171
	],
	"./fusca-&-cia-especial/1.jpg": [
		442,
		174
	],
	"./fusca-&-cia/1.jpg": [
		441,
		177
	],
	"./galileu/1.jpg": [
		443,
		180
	],
	"./gestao-&-negocios/1.jpg": [
		444,
		183
	],
	"./glamour/1.jpg": [
		445,
		186
	],
	"./globo-rural/1.jpg": [
		446,
		189
	],
	"./go-outside/1.jpg": [
		447,
		192
	],
	"./gq/1.jpg": [
		448,
		195
	],
	"./guia-astral/1.jpg": [
		449,
		198
	],
	"./guia-conhecer-fantastico/1.jpg": [
		450,
		201
	],
	"./guia-conhecer-fantástico/1.jpg": [
		451,
		204
	],
	"./guia-curso-de-desenho/1.jpg": [
		452,
		207
	],
	"./guia-da-Tv/1.jpg": [
		453,
		210
	],
	"./guia-da-cozinha-festa/1.jpg": [
		455,
		213
	],
	"./guia-da-cozinha/1.jpg": [
		454,
		216
	],
	"./guia-de-cifras-musicais/1.jpg": [
		456,
		219
	],
	"./guia-de-culinaria/1.jpg": [
		457,
		222
	],
	"./guia-de-decoracao/1.jpg": [
		458,
		225
	],
	"./guia-de-guerras/1.jpg": [
		459,
		228
	],
	"./guia-de-receitas-saudaveis/1.jpg": [
		461,
		231
	],
	"./guia-de-receitas/1.jpg": [
		460,
		234
	],
	"./guia-de-tecnologia/1.jpg": [
		462,
		237
	],
	"./guia-do-artesanato/1.jpg": [
		463,
		240
	],
	"./guia-lazer-e-turismo/1.jpg": [
		464,
		243
	],
	"./guia-minha-saude/1.jpg": [
		465,
		246
	],
	"./guia-play-games/1.jpg": [
		466,
		249
	],
	"./guia-pratico-do-professor-educacao-infantil/1.jpg": [
		467,
		252
	],
	"./guia-prático-do-professor-educacao-infantil/1.jpg": [
		468,
		255
	],
	"./hardcore/1.jpg": [
		469,
		258
	],
	"./historia-em-foco/1.jpg": [
		470,
		261
	],
	"./historias-infantis/1.jpg": [
		471,
		264
	],
	"./história-em-foco/1.jpg": [
		472,
		267
	],
	"./humanitas/1.jpg": [
		473,
		270
	],
	"./istoe-dinheiro/1.jpg": [
		93
	],
	"./istoe/1.jpg": [
		474,
		275
	],
	"./ladybug-historias/1.jpg": [
		475,
		278
	],
	"./leituras-da-historia/1.jpg": [
		476,
		281
	],
	"./locaweb/1.jpg": [
		477,
		284
	],
	"./lucre-com-arte/1.jpg": [
		478,
		287
	],
	"./malu/1.jpg": [
		479,
		290
	],
	"./manequim/1.jpg": [
		480,
		293
	],
	"./marie-claire/1.jpg": [
		481,
		296
	],
	"./masha-e-o-urso-historias/1.jpg": [
		482,
		299
	],
	"./masha-e-o-urso-histórias/1.jpg": [
		483,
		302
	],
	"./maxima-receitas/1.jpg": [
		484,
		305
	],
	"./mente-curiosa/1.jpg": [
		485,
		308
	],
	"./meu-proprio-negocio/1.jpg": [
		486,
		311
	],
	"./minecraft-quadrinhos/1.jpg": [
		487,
		314
	],
	"./minha-novela/1.jpg": [
		488,
		317
	],
	"./moda-moldes/1.jpg": [
		489,
		320
	],
	"./motor-show/1.jpg": [
		490,
		323
	],
	"./mundo-dos-super-herois/1.jpg": [
		491,
		326
	],
	"./mundo-em-foco/1.jpg": [
		492,
		329
	],
	"./natureza/1.jpg": [
		493,
		332
	],
	"./o-pequeno-ninja/1.jpg": [
		494,
		335
	],
	"./o-poder-dos-alimentos/1.jpg": [
		495,
		338
	],
	"./opala-&-cia/1.jpg": [
		496,
		341
	],
	"./patrulha-canina-livro-de-historia/1.jpg": [
		497,
		344
	],
	"./pegn/1.jpg": [
		498,
		347
	],
	"./peppa-pig/1.jpg": [
		499,
		350
	],
	"./pequenos-ambientes/1.jpg": [
		500,
		353
	],
	"./personalidades/1.jpg": [
		501,
		356
	],
	"./pilates/1.jpg": [
		502,
		359
	],
	"./playstation-revista-oficial/1.jpg": [
		503,
		362
	],
	"./ponto-cruz-faca-facil/1.jpg": [
		504,
		365
	],
	"./projetos-escolares/1.jpg": [
		505,
		368
	],
	"./psique/1.jpg": [
		506,
		371
	],
	"./receitas-e-delicias-caseiras/1.jpg": [
		508,
		374
	],
	"./receitas-e-delicias/1.jpg": [
		507,
		377
	],
	"./receitas-e-delícias/1.jpg": [
		509,
		380
	],
	"./recreio/1.jpg": [
		510,
		383
	],
	"./revista-de-culinaria/1.jpg": [
		511,
		386
	],
	"./revistas-oficial-xbox/1.jpg": [
		512,
		389
	],
	"./rolling-stone-edicao-especial/1.jpg": [
		514,
		392
	],
	"./rolling-stone/1.jpg": [
		513,
		395
	],
	"./runners/1.jpg": [
		515,
		398
	],
	"./salmos-&-anjos/1.jpg": [
		516,
		401
	],
	"./segredos-da-mente/1.jpg": [
		517,
		404
	],
	"./selecoes/1.jpg": [
		518,
		407
	],
	"./select/1.jpg": [
		519,
		410
	],
	"./sport-life/1.jpg": [
		520,
		413
	],
	"./sportbuzz/1.jpg": [
		521,
		416
	],
	"./tititi/1.jpg": [
		522,
		419
	],
	"./tpm/1.jpg": [
		523,
		422
	],
	"./trip/1.jpg": [
		524,
		425
	],
	"./uma/1.jpg": [
		525,
		428
	],
	"./vegan-fitness/1.jpg": [
		526,
		431
	],
	"./vegetarianos/1.jpg": [
		527,
		434
	],
	"./viaje-mais-luxo/1.jpg": [
		529,
		437
	],
	"./viaje-mais/1.jpg": [
		528,
		440
	],
	"./viva-bem/1.jpg": [
		530,
		443
	],
	"./viva-saude/1.jpg": [
		531,
		446
	],
	"./viva-saúde/1.jpg": [
		532,
		449
	],
	"./vogue/1.jpg": [
		533,
		452
	],
	"./womens-health/1.jpg": [
		534,
		455
	],
	"./yoga/1.jpg": [
		535,
		458
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 195;
module.exports = webpackAsyncContext;